import fiftyFiftyCardCarousel from './50-50-card-carousel';
export default fiftyFiftyCardCarousel;
